(function ($) {
  'use strict';

  var $module;
  var $petSelector;
  var $atcBtn;
  var $errorBox;
  var $petErrorBox;
  var $pageContainer;

  function formatMoney(cents) {
    var value = Math.round(Number(cents || 0));
    var currency = (window.md1Config && window.md1Config.currency) || 'USD';
    var hasDecimals = Math.abs(value % 100) !== 0;

    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: 2
      }).format(value / 100);
    } catch (error) {
      var fallback = '$' + (value / 100).toFixed(2);
      return hasDecimals ? fallback : fallback.replace(/\.00$/, '');
    }
  }

  function getMonthlyEquivalentPrice(purchaseMeta) {
    if (!purchaseMeta || !purchaseMeta.price || !purchaseMeta.cadenceDays) return 0;
    var monthly = (purchaseMeta.price / purchaseMeta.cadenceDays) * 30;
    return purchaseMeta.cadenceDays === 140 ? Math.round(monthly / 50) * 50 : Math.round(monthly / 100) * 100;
  }

  function replaceTokens(template, values) {
    var output = String(template || '');

    Object.keys(values || {}).forEach(function (key) {
      output = output.split('$' + key).join(String(values[key]));
    });

    return output;
  }

  function moduleText(attributeName, fallback) {
    if (!$module || !$module.length) return fallback;
    var value = $module.attr(attributeName);
    return typeof value === 'string' && value.length ? value : fallback;
  }

  function getVariantData(id) {
    if (!window.productVariants || !Array.isArray(window.productVariants)) return null;

    return window.productVariants.find(function (variant) {
      return String(variant.id) === String(id);
    }) || null;
  }

  function getPlanCatalog() {
    return Array.isArray(window.md1PlanCatalog) ? window.md1PlanCatalog : [];
  }

  function planNameContainsDays(name, days) {
    var safeDays = String(days).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var pattern = new RegExp('(^|\\D)' + safeDays + '(\\D|$)', 'i');
    return pattern.test(String(name || ''));
  }

  function getAllocationPlanId(allocation) {
    if (!allocation) return 0;
    return Number(
      allocation.selling_plan_id ||
      (allocation.selling_plan && allocation.selling_plan.id) ||
      0
    );
  }

  function getSellingPlanAllocation(variant, sellingPlanId) {
    if (!variant || !sellingPlanId || !Array.isArray(variant.selling_plan_allocations)) return null;

    return variant.selling_plan_allocations.find(function (allocation) {
      return String(getAllocationPlanId(allocation)) === String(sellingPlanId);
    }) || null;
  }

  function findAssignedPlanByDays(variant, days) {
    if (!variant || !Array.isArray(variant.selling_plan_allocations)) return null;

    var catalog = getPlanCatalog();
    var allocation = variant.selling_plan_allocations.find(function (candidate) {
      var candidateId = getAllocationPlanId(candidate);
      var catalogPlan = catalog.find(function (plan) {
        return String(plan.id) === String(candidateId);
      });

      return catalogPlan && planNameContainsDays(catalogPlan.name, days);
    });

    if (allocation) {
      return {
        id: getAllocationPlanId(allocation),
        allocation: allocation
      };
    }

    var fallbackIds = window.md1PlanIds || {};
    var fallbackId = days === 70
      ? fallbackIds.recurring70
      : (days === 140 ? fallbackIds.recurring140 : fallbackIds.prepaid210);
    var fallbackAllocation = getSellingPlanAllocation(variant, fallbackId);

    if (fallbackAllocation) {
      return {
        id: Number(fallbackId),
        allocation: fallbackAllocation
      };
    }

    return null;
  }

  function getSelectedPet() {
    return $petSelector.find('.grid-items.selected').first();
  }

  function getPetMeta($pet) {
    var petClass = $.trim($pet.find('.heading').text()) || 'Small Dog';
    var petWeight = $.trim($pet.find('.text').text());
    var isCatToy = String($pet.attr('data-is-cat-toy')) === 'true' ||
      String($pet.attr('data-species')).toLowerCase() === 'cat' ||
      petClass.toLowerCase().indexOf('cat') !== -1;
    var recurringDays = isCatToy ? 140 : 70;

    return {
      petClass: petClass,
      petWeight: petWeight,
      petType: isCatToy ? 'Cat / Toy Dog' : 'Dog',
      isCatToy: isCatToy,
      recurringDays: recurringDays,
      sachetCount: Number($pet.attr('data-sachet_count')) || 1,
      starterVariantId: Number($pet.attr('data-variant-starter') || 0),
      recurringVariantId: Number($pet.attr('data-variant-starter') || 0),
      prepaidVariantId: Number(
        $pet.attr('data-variant-founder-premier') ||
        $pet.attr('data-variant-founder-standard') ||
        0
      )
    };
  }

  function getSelectedDelivery() {
    return $module.find('input[name="Delivery"]:checked').first();
  }

  function getVariantBasePrice(variant) {
    return variant && Number.isFinite(Number(variant.price)) ? Number(variant.price) : 0;
  }

  function getAllocationPrice(allocation, fallbackPrice) {
    if (allocation && Number.isFinite(Number(allocation.price))) {
      return Number(allocation.price);
    }

    return Number(fallbackPrice || 0);
  }

  function getPurchaseMeta($input, petMeta) {
    var planKey = $input.attr('data-plan');
    var purchaseType = 'trial';
    var cadenceDays = 0;
    var sellingPlanId = 0;
    var allocation = null;
    var variantId = petMeta.starterVariantId;
    var label = $.trim($module.find('.purchase-option--try .variant__option-name').first().text()) || 'Try MD1';

    if (planKey === 'founder-standard') {
      purchaseType = 'recurring';
      cadenceDays = petMeta.recurringDays;
      variantId = petMeta.recurringVariantId;
      label = $.trim($module.find('[data-recurring-title]').text()) || ('Every ' + cadenceDays + ' days');
    } else if (planKey === 'founder-premier') {
      purchaseType = 'prepaid';
      cadenceDays = 210;
      variantId = petMeta.prepaidVariantId;
      label = $.trim($module.find('.subscription-plan-item--prepaid .variant__option-name').text()) || '210-day plan';
    }

    var variant = getVariantData(variantId);
    var price = getVariantBasePrice(variant);

    if (purchaseType !== 'trial') {
      var assignedPlan = findAssignedPlanByDays(variant, cadenceDays);

      if (assignedPlan) {
        sellingPlanId = assignedPlan.id;
        allocation = assignedPlan.allocation;
        price = getAllocationPrice(allocation, price);
      }
    }

    if (purchaseType !== 'trial') {
      price = Number(price || 0) * Math.max(Number(petMeta.sachetCount || 1), 1);
    }

    return {
      planKey: planKey,
      purchaseType: purchaseType,
      cadenceDays: cadenceDays,
      sellingPlanId: Number(sellingPlanId || 0),
      allocation: allocation,
      variantId: Number(variantId || 0),
      price: Number(price || 0),
      label: label
    };
  }

  function validatePlanConfiguration(purchaseMeta) {
    if (purchaseMeta.purchaseType === 'trial') {
      return { valid: true };
    }

    if (!purchaseMeta.sellingPlanId) {
      return {
        valid: false,
        message: replaceTokens(
          moduleText(
            'data-error-unavailable',
            'The $days-day Recharge plan is not active or assigned to this pet class.'
          ),
          { days: purchaseMeta.cadenceDays }
        )
      };
    }

    var variant = getVariantData(purchaseMeta.variantId);
    var allocation = getSellingPlanAllocation(variant, purchaseMeta.sellingPlanId);

    if (!allocation) {
      return {
        valid: false,
        message: replaceTokens(
          moduleText(
            'data-error-assignment',
            'The $days-day Recharge plan is not assigned to the selected product variant.'
          ),
          { days: purchaseMeta.cadenceDays }
        )
      };
    }

    return { valid: true };
  }

  function showError(message) {
    if ($errorBox.length) {
      $errorBox.text(message).stop(true, true).fadeIn();
      return;
    }

    window.alert(message);
  }

  function showPetError(message) {
    if ($petErrorBox.length) {
      $petErrorBox.text(message).stop(true, true).fadeIn();
      return;
    }

    showError(message);
  }

  function clearErrors() {
    $errorBox.stop(true, true).hide().text('');
    $petErrorBox.stop(true, true).hide().text('');
  }

  function getAnalyticsData(petMeta, purchaseMeta) {
    var variant = getVariantData(purchaseMeta.variantId);

    return {
      product_id: window.md1Config && window.md1Config.productId,
      product_handle: window.md1Config && window.md1Config.productHandle,
      product_title: window.md1Config && window.md1Config.productTitle,
      variant_id: purchaseMeta.variantId,
      variant_sku: variant ? (variant.sku || '') : '',
      pet_class: petMeta.petClass,
      pet_weight: petMeta.petWeight,
      purchase_type: purchaseMeta.purchaseType,
      purchase_label: purchaseMeta.label,
      cadence_days: purchaseMeta.cadenceDays,
      selling_plan_id: purchaseMeta.sellingPlanId || null,
      value: purchaseMeta.price / 100,
      currency: (window.md1Config && window.md1Config.currency) || 'USD'
    };
  }

  function publishAnalytics(eventName, data) {
    var namespacedEvent = 'matterdays_md1:' + eventName;

    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var result = window.Shopify.analytics.publish(namespacedEvent, data);
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (error) {
      console.warn('[MD1] Shopify analytics publish failed', error);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push($.extend({ event: 'md1_' + eventName }, data));

    try {
      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'MD1' + eventName.replace(/(^|_)([a-z])/g, function (_, __, letter) {
          return letter.toUpperCase();
        }), data);
      }
    } catch (error) {
      console.warn('[MD1] Meta custom event failed', error);
    }
  }

  function updateFirstMedia($scope, imageUrl) {
    if (!$scope.length || !imageUrl) return;

    var $mainSlide = $scope.find('.thumbnail-media--main-media .swiper-slide[data-swiper-slide-index="0"]').first();
    var $thumbSlide = $scope.find('.thumbnail-media--thumbnails .swiper-slide[data-swiper-slide-index="0"]').first();

    if (!$mainSlide.length) $mainSlide = $scope.find('.thumbnail-media--main-media .swiper-slide').eq(0);
    if (!$thumbSlide.length) $thumbSlide = $scope.find('.thumbnail-media--thumbnails .swiper-slide').eq(0);

    /* MD speed: sized URLs instead of the full-size original; skip when the slide already shows this file */
    var sep = imageUrl.indexOf('?') > -1 ? '&' : '?';
    var base = imageUrl.split('?')[0].split('/').pop();
    [[$mainSlide.find('img').first(), [360, 540, 720, 1080, 1445], 1080], [$thumbSlide.find('img').first(), [160, 240], 240]].forEach(function (item) {
      var $image = item[0];
      if (!$image.length) return;
      var cur = ($image.attr('src') || '').split('?')[0].split('/').pop();
      if (cur && cur === base && $image.attr('srcset')) return;
      $image.attr('srcset', item[1].map(function (w) { return imageUrl + sep + 'width=' + w + ' ' + w + 'w'; }).join(', '));
      $image.attr('src', imageUrl + sep + 'width=' + item[2]);
      if (!$image.attr('sizes')) $image.attr('sizes', item[2] < 400 ? '80px' : '100vw');
    });
  }

  function updateProductMedia(planKey) {
    var imageUrl = planKey === 'starter'
      ? 'https://cdn.shopify.com/s/files/1/0587/7448/7104/files/MD1_Shopify_pouch_clean.jpg?v=1788435832'
      : 'https://matterdays.md/cdn/shop/files/MD1_hero_spec.webp?v=1774546395';

    updateFirstMedia($('#productMediaDesktop'), imageUrl);
    updateFirstMedia($('#productMediaMobile'), imageUrl);

    window.setTimeout(function () {
      updateFirstMedia($('#productMediaDesktop'), imageUrl);
      updateFirstMedia($('#productMediaMobile'), imageUrl);
    }, 100);
  }

  function updateCoaLinks() {
    var coaUrl = window.md1Config && window.md1Config.coaUrl;
    if (!coaUrl) return;

    $('a[data-md1-coa-link], a').each(function () {
      var $link = $(this);
      var linkText = $.trim($link.text()).toLowerCase();

      if ($link.is('[data-md1-coa-link]') || linkText === 'view test results') {
        $link.attr({
          href: coaUrl,
          target: '_blank',
          rel: 'noopener noreferrer'
        });
      }
    });
  }

  function setButtonLabel(purchaseMeta) {
    if (!$atcBtn.length) return;

    var attributeName = purchaseMeta.purchaseType === 'trial'
      ? 'data-cta-trial-template'
      : (purchaseMeta.purchaseType === 'prepaid'
        ? 'data-cta-prepaid-template'
        : 'data-cta-recurring-template');

    var fallback = purchaseMeta.purchaseType === 'trial'
      ? 'Try MD1 · $price'
      : (purchaseMeta.purchaseType === 'prepaid'
        ? 'Subscribe · 210-Day Prepay'
        : 'Subscribe · $monthly/month');

    var template = moduleText(attributeName, moduleText('data-cta-template', fallback));
    var monthlyPrice = getMonthlyEquivalentPrice(purchaseMeta);
    var label = replaceTokens(template, {
      price: formatMoney(purchaseMeta.price),
      monthly: formatMoney(monthlyPrice),
      days: purchaseMeta.cadenceDays || ''
    });

    $atcBtn.attr('data-md1-label', label);

    if (!$atcBtn.hasClass('is-loading')) {
      $atcBtn.text(label);
    }
  }

  function setLoading(isLoading) {
    if (isLoading) {
      $atcBtn
        .addClass('is-loading')
        .text(moduleText('data-adding-label', 'Adding...'))
        .attr('aria-busy', 'true');
      return;
    }

    $atcBtn.removeClass('is-loading').attr('aria-busy', 'false');
    $atcBtn.text($atcBtn.attr('data-md1-label') || 'Add to Cart');
  }

  function updateDynamicText(petMeta) {
    var recurringTitleTemplate = $module.find('[data-recurring-title]').attr('data-text-template') || 'Standard';
    var recurringCopyTemplate = $module.find('[data-recurring-copy]').attr('data-text-template') || 'Billed $charge every $days days';

    $module.find('[data-recurring-title]').text(
      replaceTokens(recurringTitleTemplate, { days: petMeta.recurringDays })
    );
    $module.find('[data-recurring-copy]').text(
      replaceTokens(recurringCopyTemplate, { days: petMeta.recurringDays })
    );
  }

  function updatePrices(petMeta) {
    var $trialInput = $module.find('input[data-plan="starter"]');
    var $recurringInput = $module.find('input[data-plan="founder-standard"]');
    var $prepaidInput = $module.find('input[data-plan="founder-premier"]');
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();

    var trialMeta = getPurchaseMeta($trialInput, petMeta);
    var recurringMeta = getPurchaseMeta($recurringInput, petMeta);
    var prepaidMeta = getPurchaseMeta($prepaidInput, petMeta);

    $module.find('.starter-price').text(formatMoney(trialMeta.price));
    $module.find('.fs-price').text('About ' + formatMoney(getMonthlyEquivalentPrice(recurringMeta)) + '/mo');
    $module.find('.fp-price').text(formatMoney(prepaidMeta.price));

    var prepaidCycles = recurringMeta.cadenceDays > 0
      ? (prepaidMeta.cadenceDays / recurringMeta.cadenceDays)
      : 0;
    var comparableRecurringTotal = prepaidCycles > 0
      ? Math.round(recurringMeta.price * prepaidCycles)
      : 0;
    var saving = Math.max(comparableRecurringTotal - prepaidMeta.price, 0);
    var $saving = $module.find('[data-prepaid-saving]');
    var savingTemplate = $saving.attr('data-text-template') || 'Save $saving';

    if (saving > 0) {
      $saving.text(replaceTokens(savingTemplate, { saving: formatMoney(saving) })).prop('hidden', false);
    } else {
      $saving.prop('hidden', true);
    }

    return {
      trial: trialMeta,
      recurring: recurringMeta,
      prepaid: prepaidMeta
    };
  }

  function updateSubscriptionSummary(petMeta, prices) {
    var prepaidSelected = false;
    var selectedMeta = prepaidSelected ? prices.prepaid : prices.recurring;
    var monthlyPrice = getMonthlyEquivalentPrice(selectedMeta);
    var $copy = $module.find('[data-subscription-selected-copy]');
    var template = prepaidSelected
      ? ($copy.attr('data-prepaid-template') || 'Billed $charge every $days days')
      : ($copy.attr('data-recurring-template') || 'Billed $charge every $days days');
    var summaryValues = {
      charge: formatMoney(selectedMeta.price),
      monthly: formatMoney(monthlyPrice),
      days: selectedMeta.cadenceDays || petMeta.recurringDays,
      pouches: petMeta.sachetCount || 1,
      pouches: petMeta.sachetCount || 1,
      pouches: petMeta.sachetCount || 1
    };

    var $monthlyValue = $module.find('[data-subscription-monthly-value]');
    if ($monthlyValue.length) {
      $monthlyValue.text(summaryValues.monthly + '/month');
    } else {
      $module.find('[data-subscription-selected-price]').text(summaryValues.monthly + '/month');
    }

    template = 'Billed $charge every $days days';
    $copy.text(replaceTokens(template, $.extend({}, summaryValues, { pouches: petMeta.sachetCount || 1 })));
  }

  function updateGuaranteeLine() {  
    if (!$atcBtn.length) return;

    var text = moduleText('data-guarantee-text', 'Free Shipping · 30-Day Satisfaction Guarantee');
    if (!text) return;

    var $wrapper = $atcBtn.closest('.paymentButtonsWrapper');
    if (!$wrapper.length) return;

    var matchesGuarantee = function () {
      var $element = $(this);
      var candidateText = $.trim($element.text());
      return /free shipping|satisfaction guarantee|money-back guarantee|third-party tested/i.test(candidateText) &&
        !$element.find('button,a,input,select,textarea').length;
    };

    var $line = $wrapper.find('.md1-guarantee-line').first();
    if (!$line.length) {
      $line = $wrapper.find('p,small,div,span').filter(matchesGuarantee).last();
    }
    if (!$line.length) {
      $line = $wrapper.siblings('.md1-guarantee-line').first();
    }
    if (!$line.length) {
      $line = $wrapper.parent().children().filter(function () {
        return this !== $wrapper[0] && matchesGuarantee.call(this);
      }).first();
    }

    if ($line.length) {
      $line.addClass('md1-guarantee-line');
    } else {
      $line = $('<div class="md1-guarantee-line" aria-live="polite"></div>').insertAfter($wrapper);
    }

    $line.text(text);
  }

  function updateUI() {
    if (!$module.length || !$petSelector.length) return;

    var $pet = getSelectedPet();
    var $recurringInput = $module.find('input[data-plan="founder-standard"]');
    var $prepaidInput = $module.find('input[data-plan="founder-premier"]');
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();
    $prepaidInput.closest('.subscription-plan-item').remove();
    $prepaidInput = $();
    var $prepaidItem = $prepaidInput.closest('.subscription-plan-item');
    var $shell = $module.find('.subscription-choice-shell');

    if (!$pet.length) {
      var $selectedInputWithoutPet = getSelectedDelivery();
      var selectedPlanKey = $selectedInputWithoutPet.attr('data-plan') || 'founder-standard';
      var subscriptionSelectedWithoutPet = selectedPlanKey !== 'starter';
      var prepaidSelectedWithoutPet = selectedPlanKey === 'founder-premier';

      $module.toggleClass('is-subscription-active', subscriptionSelectedWithoutPet);
      $module.toggleClass('is-try-active', !subscriptionSelectedWithoutPet);
      $module.toggleClass('is-prepaid-active', prepaidSelectedWithoutPet);
      $shell.toggleClass('is-subscription-selected', subscriptionSelectedWithoutPet);
      $shell.find('[data-subscribe-trigger]').attr('aria-pressed', subscriptionSelectedWithoutPet ? 'true' : 'false');
      $module.find('[data-subscription-monthly-value], [data-subscription-selected-price]').text('Dogs\u00a0from\u00a0$39/month \u00b7 Cats\u00a0$19.50/month');
      $module.find('[data-subscription-selected-copy]').text("Choose your pet's size above to see your price.");
      $module.find('.price.fs-price').text("Choose your pet's size to see your price");
      $module.find('[data-subscription-monthly-value], [data-subscription-selected-price]').text('Dogs\u00a0from\u00a0$39/month \u00b7 Cats\u00a0$19.50/month');
      $module.find('[data-subscription-selected-copy]').text("Choose your pet's size above to see your price.");
      $atcBtn.attr('data-md1-label', 'Choose a size').text('Choose a size').prop('disabled', true).attr('aria-disabled', 'true');
      return;
    }

    var petMeta = getPetMeta($pet);
    $atcBtn.prop('disabled', false).removeAttr('aria-disabled');

    var prepaidAvailable = false;
    $prepaidItem.prop('hidden', !prepaidAvailable);
    $shell.toggleClass('is-cat-toy', petMeta.isCatToy);

    updateDynamicText(petMeta);
    var prices = updatePrices(petMeta);

    $recurringInput.attr('data-sellid', prices.recurring.sellingPlanId || '');
    $prepaidInput.attr('data-sellid', prices.prepaid.sellingPlanId || '');

    if (!prepaidAvailable && $prepaidInput.prop('checked')) {
      $recurringInput.prop('checked', true);
      showError(moduleText(
        'data-error-cat-reset',
        'The prepaid plan is not available for Cat / Toy Dog. Recurring has been selected.'
      ));

      publishAnalytics('purchase_option_selected', $.extend(
        { reset_reason: 'prepaid_not_available_for_cat_toy' },
        getAnalyticsData(petMeta, prices.recurring)
      ));
    }

    var $selectedInput = getSelectedDelivery();
    if (!$selectedInput.length) {
      $selectedInput = $recurringInput.prop('checked', true);
    }

    var purchaseMeta = getPurchaseMeta($selectedInput, petMeta);
    var subscriptionSelected = purchaseMeta.purchaseType !== 'trial';
    var prepaidSelected = purchaseMeta.purchaseType === 'prepaid';

    $module.toggleClass('is-subscription-active', subscriptionSelected);
    $module.toggleClass('is-try-active', !subscriptionSelected);
    $module.toggleClass('is-prepaid-active', prepaidSelected);
    $shell.toggleClass('is-subscription-selected', subscriptionSelected);
    $shell.find('[data-subscribe-trigger]').attr('aria-pressed', subscriptionSelected ? 'true' : 'false');

    updateSubscriptionSummary(petMeta, prices);
    setButtonLabel(purchaseMeta);
    updateGuaranteeLine();
  }

  function updateCartCount() {
    if (!window.wetheme || !window.routes || !window.routes.cart_url) return;

    $.getJSON(window.routes.cart_url + '?view=compare').done(function (cart) {
      if (window.wetheme.updateCartCount) window.wetheme.updateCartCount(cart);
    });
  }

  function cartContainsTrial() {
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';

    return $.getJSON(cartUrl + '.js').then(function (cart) {
      return (cart.items || []).some(function (item) {      
        var properties = item.properties || {};
        return properties._md1_purchase_type === 'trial' || properties._md1_purchase_type === 'Try MD1';
      });
    }, function () {
      return false;
    });
  }

  function updateCartAnalyticsAttributes(analyticsData) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    return $.ajax({
      url: root + 'cart/update.js',
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify({
        attributes: {
          _md1_pet_class: analyticsData.pet_class,
          _md1_purchase_type: analyticsData.purchase_type,
          _md1_purchase_label: analyticsData.purchase_label,
          _md1_cadence_days: String(analyticsData.cadence_days || 0),
          _md1_variant_id: String(analyticsData.variant_id || ''),
          _md1_selling_plan_id: String(analyticsData.selling_plan_id || '')
        }
      })
    });
  }

  function finishCartAction(responseJson) {
    var cartType = $pageContainer.data('cart-type');

    if (cartType === 'drawer' && window.eventBus && window.eventBus.emit) {
      window.eventBus.emit('update:cart:drawer', responseJson);
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
      updateCartCount();
      return;
    }

    window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  }

  function addSelectedPurchaseToCart() {
    if ($atcBtn.hasClass('is-disabled') || $atcBtn.hasClass('is-loading')) return;

    clearErrors();

    var $pet = $petSelector.find('.grid-items.selected').first();
    if (!$pet.length) {
      showPetError(moduleText('data-error-pet', 'Please select your pet.'));
    
      var $petSection = $('.variant--container-pet').first();
      if ($petSection.length) {
        $('html, body').animate({ scrollTop: $petSection.offset().top - 200 }, 500);
      }
      return;
    }

    var $selectedDelivery = getSelectedDelivery();
    if (!$selectedDelivery.length) {
      showError(moduleText('data-error-purchase', 'Please choose Try MD1 or Subscribe + Save.'));
      return;
    }

    var petMeta = getPetMeta($pet);
    var purchaseMeta = getPurchaseMeta($selectedDelivery, petMeta);

    if (petMeta.isCatToy && purchaseMeta.purchaseType === 'prepaid') {
      $module.find('input[data-plan="founder-standard"]').prop('checked', true).trigger('change');
      showError(moduleText(
        'data-error-cat-reset',
        'The prepaid plan is not available for Cat / Toy Dog. Recurring has been selected.'
      ));
      return;
    }

    if (!purchaseMeta.variantId) {
      showError(moduleText('data-error-variant', 'This pet option is not available for the selected purchase type.'));
      return;
    }

    var planValidation = validatePlanConfiguration(purchaseMeta);
    if (!planValidation.valid) {
      showError(planValidation.message);
      return;
    }

    var proceed = purchaseMeta.purchaseType === 'trial'
      ? cartContainsTrial().then(function (hasTrial) {
          if (hasTrial) {
            showError(moduleText('data-error-trial-limit', 'Only one Try MD1 trial can be added to the cart.'));
            return false;
          }
          return true;
        })
      : $.Deferred().resolve(true).promise();

    proceed.then(function (canAdd) {
      if (!canAdd) return;

      var variant = getVariantData(purchaseMeta.variantId);
      var variantSku = variant ? (variant.sku || '') : '';
      var sachetCount = purchaseMeta.purchaseType === 'trial' ? 1 : petMeta.sachetCount;
      var uniqueId = Date.now().toString(36) + Math.random().toString(36).slice(2);
      var analyticsData = getAnalyticsData(petMeta, purchaseMeta);   

      var mdPayload = {
        petType: petMeta.petType,
        petClass: petMeta.petClass,
        petWeight: petMeta.petWeight,
        sachetCount: sachetCount,
        sku: variantSku,
        purchaseType: purchaseMeta.purchaseType,
        purchaseLabel: purchaseMeta.label,
        subscriptionInterval: purchaseMeta.cadenceDays,
        sellingPlanId: purchaseMeta.sellingPlanId || null
      };

      var lineProperties = {
        _md_payload: JSON.stringify(mdPayload),
        _uid: uniqueId,
        _md1_pet_class: petMeta.petClass,
        _md1_purchase_type: purchaseMeta.purchaseType,
        _md1_purchase_label: purchaseMeta.label,
        _md1_cadence_days: String(purchaseMeta.cadenceDays || 0),
        _md1_sachet_count: String(sachetCount),
        _md1_selling_plan_id: String(purchaseMeta.sellingPlanId || ''),
        _md1_variant_sku: variantSku
      };

      var item = {
        id: purchaseMeta.variantId,
        quantity: sachetCount,
        properties: lineProperties
      };

      if (purchaseMeta.purchaseType !== 'trial') {
        item.selling_plan = purchaseMeta.sellingPlanId;
        item.properties.Included = 'MD1 Canister';
      }

      var payload = { items: [item] };
      var cartType = $pageContainer.data('cart-type');
      if (cartType === 'drawer') payload.sections = 'cart-drawer';

      var addUrl = (window.routes && window.routes.cart_add_url)
        ? window.routes.cart_add_url
        : '/cart/add.js';

      setLoading(true);

      $.ajax({
        url: addUrl,
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(payload),
        contentType: 'application/json',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).done(function (responseJson) {
        clearErrors();
        publishAnalytics('add_to_cart', analyticsData);

        updateCartAnalyticsAttributes(analyticsData).always(function () {
          finishCartAction(responseJson);
        });
      }).fail(function (xhr) {
        var message = 'Something went wrong. Please try again.';

        try {
          var response = JSON.parse(xhr.responseText);
          if (response.description) message = response.description;
          else if (response.errors) message = response.errors;
        } catch (error) {}

        showError(message);
      }).always(function () {
        setLoading(false);
      });
    });
  }

  function bindEvents() {
    $petSelector.on('click', '.grid-items', function () {
      var $pet = $(this);
      $petSelector.find('.grid-items').removeClass('selected');
      $pet.addClass('selected');
      clearErrors();
      updateUI();

      var petMeta = getPetMeta($pet);
      var purchaseMeta = getPurchaseMeta(getSelectedDelivery(), petMeta);
      publishAnalytics('pet_class_selected', getAnalyticsData(petMeta, purchaseMeta));
    });      

    $module.on('click', '[data-subscribe-trigger]', function (event) {
      event.preventDefault();
      var $recurringInput = $module.find('input[data-plan="founder-standard"]');

      if (!$module.hasClass('is-subscription-active')) {
        $recurringInput.prop('checked', true).trigger('change');
      }
    });

    $module.on('change', 'input[name="Delivery"]', function () {
      clearErrors();
      updateProductMedia($(this).attr('data-plan'));
      updateUI();

      var $pet = getSelectedPet();
      if (!$pet.length) return;
      var petMeta = getPetMeta($pet);
      var purchaseMeta = getPurchaseMeta($(this), petMeta);
      publishAnalytics('purchase_option_selected', getAnalyticsData(petMeta, purchaseMeta));
    });

    $atcBtn.on('click', addSelectedPurchaseToCart);
  }

  $(function () {
    $module = $('.subscribe-container').first();
    $petSelector = $('.pet-selector').first();
    $atcBtn = $('.custom-add-to-cart').first();
    $errorBox = $('.custom-atc-error').first();
    $petErrorBox = $('.custom-atc-error-pet').first();
    $pageContainer = $('#PageContainer');

    if (!$module.length || !$petSelector.length || !$atcBtn.length) return;

    // Default size on load: Small Dog (pre-selected in Liquid), or the size matching ?variant= if present.
    var urlVariant = '';
    try { urlVariant = String(new URLSearchParams(window.location.search).get('variant') || ''); } catch (e) {}
    var $defaultPet = $();
    if (urlVariant) {
      $defaultPet = $petSelector.find('.grid-items').filter(function () {
        var $p = $(this);
        return [$p.attr('data-variant-starter'), $p.attr('data-variant-founder-standard'), $p.attr('data-variant-founder-premier')].indexOf(urlVariant) !== -1;
      }).first();
    }
    if (!$defaultPet.length) $defaultPet = $petSelector.find('.grid-items.selected').first();
    if (!$defaultPet.length) {
      $defaultPet = $petSelector.find('.grid-items').filter(function () {
        return $.trim($(this).find('.heading').text()).toLowerCase() === 'small dog';
      }).first();
    }
    $petSelector.find('.grid-items').removeClass('selected');
    $defaultPet.addClass('selected');
    if (typeof window.updateVariantText === 'function') window.updateVariantText();

    // Required default state: Subscribe + Save > Standard on every fresh PDP load.
    $module.find('input[name="Delivery"]').prop('checked', false);
    $module.find('input[data-plan="founder-standard"]').prop('checked', true);

    getSelectedPet();
    bindEvents();
    updateCoaLinks();
    updateUI();
    updateProductMedia('founder-standard');
    updateGuaranteeLine();
  var $feedingGuide = $(document).find('.collapsible-tab').filter(function() {
    return $(this).find('.text-with-icon--text').first().text().trim() === 'Feeding Guide';
  }).first();
  var $dosingGuide = $(document).find('.md1-dosing-guide').first();
  var $feedingContent = $feedingGuide.find('.collapsible-content .content').first();
  if ($dosingGuide.length && $feedingContent.length && !$feedingContent.find('.md1-dosing-guide').length) {
    var $halfStartNote = $feedingContent.find('p').filter(function() {
      return $(this).text().indexOf('Start with half') !== -1;
    }).first();
    $dosingGuide.appendTo($feedingContent);
    if ($halfStartNote.length) {
      $halfStartNote.text('Start at half the amount for the first 7–10 days.').insertAfter($dosingGuide);
    } else {
      $('<p class="md1-dosing-start-note">Start at half the amount for the first 7–10 days.</p>').insertAfter($dosingGuide);
    }
  }
    $module.find('.subscription-plan-item--recurring').hide();
  $module.find('.subscription-plans-grid').each(function(){ this.style.setProperty('display','none','important'); this.style.setProperty('margin','0','important'); this.style.setProperty('padding','0','important'); this.style.setProperty('min-height','0','important'); this.style.setProperty('height','0','important'); });
    $module.find('.purchase-option--try .variant__option-name').text('One pouch');
    if (!document.getElementById('md1-simple-subscription-style')) {
      $('<style id="md1-simple-subscription-style">.subscription-selected-price{font-size:50px!important;font-weight:700!important;line-height:50px!important}.subscription-selected-copy{color:rgb(139, 131, 120)!important;font-size:18px!important;font-weight:400!important;line-height:25.2px!important}.subscription-plans-grid{display:none!important;margin:0!important;padding:0!important;min-height:0!important;height:0!important}.subscription-plan-item--recurring{display:none!important}</style>').appendTo('head');
    }
  });
})(jQuery);   

document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.querySelector('.paymentButtonsWrapper');
  if (!wrapper || !wrapper.parentNode) return;

  /* MD 20/10/26: observe a fixed zero-height marker; the sentinel only reserves space. Observing the resizing sentinel made the bar flip on/off. */
  var marker = document.createElement('div');
  marker.className = 'paymentButtonsWrapper-marker';
  marker.style.height = '0';
  var sentinel = document.createElement('div');
  sentinel.className = 'paymentButtonsWrapper-sentinel';
  wrapper.parentNode.insertBefore(marker, wrapper);
  wrapper.parentNode.insertBefore(sentinel, wrapper);

  new IntersectionObserver(function (entries) {
    var e = entries[0];
    var makeSticky = !e.isIntersecting && e.boundingClientRect.top < 0;
    if (makeSticky === wrapper.classList.contains('sticky')) return;
    if (makeSticky) {
      sentinel.style.height = wrapper.offsetHeight + 'px';
      wrapper.classList.add('sticky');
    } else {
      wrapper.classList.remove('sticky');
      sentinel.style.height = '';
    }
  }, { threshold: 0 }).observe(marker);
});
